import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors, fonts } from 'shared/defaultTheme';

const TopbarMenuLinks = ({ title, icon, path, onClick }) => (
  <CustomLink className="topbar__link" to={path} onClick={onClick}>
    {icon}
    <Text className="topbar__link-title text-uppercase">{title}</Text>
  </CustomLink>
);

TopbarMenuLinks.defaultProps = {
  onClick: undefined,
};

TopbarMenuLinks.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  path: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

const CustomLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    fill: ${colors.black};
    height: 16px;
    width: 15px;
    margin-right: 19px;
  }
`;

const Text = styled.p`
  color: ${colors.black};
  font-family: ${fonts.default};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: -0.28px;
  line-height: 14px;
`;

export default TopbarMenuLinks;
